import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spacing, color, border, shadow } from '@metro-ui/tokens/js';
import { fontStack, responsiveProp, responsivePropTypes, } from '../utils';
import { rgba } from '../utils/rgba';
export var Card = styled(React.forwardRef(function (_a, ref) {
    var padding = _a.padding, elevation = _a.elevation, radius = _a.radius, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["padding", "elevation", "radius", "className", "children"]);
    return (React.createElement("div", __assign({}, htmlAttributes, { className: className, ref: ref }), children));
}))(function (_a) {
    var padding = _a.padding, _b = _a.elevation, elevation = _b === void 0 ? 'medium' : _b, radius = _a.radius, overflowHidden = _a.overflowHidden;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    background: ", ";\n    ", ";\n    ", ";\n    box-shadow: ", " ", ";\n    ", "\n  "], ["\n    ", ";\n    background: ", ";\n    ", ";\n    ", ";\n    box-shadow: ", " ", ";\n    ", "\n  "])), fontStack, color.contrast.white, radius && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), border.radius[radius]), overflowHidden && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      overflow: hidden;\n    "], ["\n      overflow: hidden;\n    "]))), shadow[elevation].default, rgba(shadow.color, shadow.alpha), responsiveProp(padding, undefined, function (val) { return val && "padding: " + spacing[val] + ";"; }));
});
Card.propTypes = {
    padding: responsivePropTypes(PropTypes.oneOf([
        'none',
        'x-small',
        'small',
        'medium',
        'large',
        'x-large',
        'xx-large',
    ])),
    elevation: PropTypes.oneOf(['medium', 'large', 'xx-large']),
    radius: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
    overflowHidden: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Card.js.map